/**
 * Pushes a semantic event to the GTM dataLayer. No-op on the server or when GTM
 * has not initialized the dataLayer (e.g. `NEXT_PUBLIC_GTM_ID` unset).
 *
 * `Window.dataLayer` is already declared by `@next/third-parties`.
 *
 * @param event - Event name, e.g. `nav_click`
 * @param payload - Extra event properties
 */
export function pushDataLayer(event: string, payload: Record<string, unknown> = {}): void {
  if (typeof window === 'undefined') return;
  const dataLayer = (window as Window & { dataLayer?: unknown[] }).dataLayer;
  if (!Array.isArray(dataLayer)) return;
  dataLayer.push({ event, ...payload });
}

export const HUB_EVENTS = {
  NAV_CLICK: 'nav_click',
  DROP_REVEALED: 'drop_revealed',
  GIVEAWAY_CLICK: 'giveaway_click',
  ALERTS_SUBMIT_SUCCESS: 'alerts_submit_success',
  ALERTS_SUBMIT_ERROR: 'alerts_submit_error',
} as const;
